import {
  SET_INSTALLMENT_BINS,
  SET_SELECTED_PLAN,
  CLEAR_INSTALLMENT_DATA,
} from '../paymentActions';

interface InstallmentState {
  bankBins: string[];
  providerKey: string;
  totalPayableAmount: number;
  isInstallmentSelected: boolean;
  selectedPlanId: string;
  providerID:number;
}

const initialState: InstallmentState = {
  bankBins: [],
  providerKey: '',
  totalPayableAmount: 0,
  isInstallmentSelected: false,
  selectedPlanId: '',
  providerID:0
};

const installmentReducer = (
  state: InstallmentState = initialState,
  action: any
): InstallmentState => {
  switch (action.type) {
    case SET_INSTALLMENT_BINS:
      return {
        ...state,
        bankBins: action.payload.bank_bins || [],
        providerKey: action.payload.provider_key || '',
        totalPayableAmount: action.payload.total_payable_amount || 0,
        isInstallmentSelected: true,
      };
    case SET_SELECTED_PLAN:
      return {
        ...state,
        selectedPlanId: action.payload.selectedPlanId,
        providerKey: action.payload.providerKey,
        providerID: action.payload.providerID
      };
    case CLEAR_INSTALLMENT_DATA:
      return initialState;
    default:
      return state;
  }
};

export default installmentReducer;
